import React from 'react';
import HelmetHeader from './../components/HelmetHeader';
import Footer from './../components/Footer';
import Layout from './../components/layout';
import Container from './../components/Container';
import Row from './../components/Row';

const gestaltLogo = "https://s3.eu-central-1.amazonaws.com/berlin-robotics/logo/gestalt-robotics-logo.png";

const InSystemsLogo = "http://www.insystems.de/wp-content/uploads/2017/02/insystems-bildmarke-150x150.jpg";

const pageKeywords = [
	'Jobs',
	'Software engineer',
	'agile software development',
	'software architecture',
	'Automation',
	'software deployment',
	'Interface Design',
	'InSystems Automation GmbH',
	'Gestalt Robotics GmbH',
];

const JobsPage = (props) => {
	const dataHeader = {
		title: "Jobs",
		meta: [
			{ name: 'description', content: 'Job section with the latest jobs available to the community!' },
			{ name: 'keywords', content: pageKeywords.join(',') },
		],
	};
	return (
		<Layout>
			<HelmetHeader data={dataHeader} />
			{/* <!-- blog-section ================================================== --> */}
			<section className="schedule-section3">
				<Container>
					<div className="schedule-box">
						<div className="title-section">
						<span>Latest</span>
							<h1>Jobs for the community</h1>
							<p>Job section with the latest jobs available to the community!</p>
						</div>
						
						<div className="schedule-block">
							<h1>InSystems Automation GmbH</h1>
							<Row>
								<div className="col-lg-8">
									<Row>
										<div className="col-md-6">
											<div className="schedule-image">
												<img src={InSystemsLogo} alt="InSystems Automation GmbH" title="InSystems Automation GmbH" />
												<div className="hover-box">
													<div className="white-box">
														<p>Hochsprachen-Programmierer (m/w)</p>
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-6">
											<div className="schedule-content">
												<h2>Hochsprachen-Programmierer (m/w)</h2>
												<p>Wir suchen engagierte Hochsprachen-Programmierer für die objektorientierte Applikationsentwicklung und für anspruchsvolle Softwarelösungen im Bereich der Automatisierungstechnik und Sondermaschinenbau.</p>
												<ul className="schedule-list">
													<li>Team fähig aber auch Selbstständig</li>
													<li>Kommunikationsstark und wissensdurstig</li>
													<li>Soliden Englischkenntnisse</li>
												</ul>
											</div>
										</div>
									</Row>
								</div>
								<div className="col-lg-4">
									<div className="schedule-speakers">
										<h2>Skills</h2>
										<Row>
											<div className="col">
												<ul className="speaker-list">
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m1.jpg" alt="C++" />
														<span>C++</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m2.jpg" alt="interface design and software architecture" />
														<span>QT und/oder MFC</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m2.jpg" alt="software architecture design" />
														<span>MSSQL und/oder Oracle</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m3.jpg" alt="PhD in Computer Science" />
														<span>C# (WPF)</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m4.jpg" alt="Flexible, goal-oriented" />
														<span>ASP.net und/oder Microsoft Reporting Services (SSRS)</span>
													</li>
												</ul>
											</div>
											{/* <div className="col-md-6">
												<ul className="speaker-list">
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m5.jpg" alt="Gestalt Robotics GmbH" />
														<span>Amy Adams</span>
													</li>
												</ul>
											</div> */}
										</Row>
									</div>
								</div>
							</Row>
						</div>

						{/* Gestalt Robotics */}
						<div className="schedule-block">
							<h1>Gestalt Robotics GmbH</h1>
							<Row>
								<div className="col-lg-8">
									<Row>
										<div className="col-md-6">
											<div className="schedule-image">
												<img src={gestaltLogo} alt="Gestalt Robotics GmbH" title="Gestalt Robotics GmbH" />
												{/* <img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/lg1.jpg" alt="Gestalt Robotics GmbH" /> */}
												<div className="hover-box">
													<div className="white-box">
														<p>Software Engineer</p>
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-6">
											<div className="schedule-content">
												<h2>Software Engineer</h2>
												<p>GESTALT Robotics is looking for a skilled and talented software engineer in order to strengthen the team in the field of agile software development and software deployment for intelligent autonomous systems. This comprises the following tasks in particular</p>
												<ul className="schedule-list">
													<li>Software architecture and Interface Design and Implementation</li>
													<li>DevOps</li>
													<li>Testing and Documentation</li>
												</ul>
											</div>
										</div>
									</Row>
								</div>
								<div className="col-lg-4">
									<div className="schedule-speakers">
										<h2>Skills</h2>
										<Row>
											<div className="col">
												<ul className="speaker-list">
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m1.jpg" alt="C++, Java and/or Python" />
														<span>C++, Java and/or Python</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m2.jpg" alt="interface design and software architecture" />
														<span>Experience in interface design and software architecture design as well as software deployment</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m2.jpg" alt="software architecture design" />
														<span>Experience with software architecture design as well as software deployment</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m3.jpg" alt="PhD in Computer Science" />
														<span>Master's degree or PhD in Computer Science, Engineering, Mathematics or a related discipline</span>
													</li>
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m4.jpg" alt="Flexible, goal-oriented" />
														<span>Self-directed, flexible, goal-oriented and strong sense of autonomy</span>
													</li>
												</ul>
											</div>
											{/* <div className="col-md-6">
												<ul className="speaker-list">
													<li>
														<img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/others/m5.jpg" alt="Gestalt Robotics GmbH" />
														<span>Amy Adams</span>
													</li>
												</ul>
											</div> */}
										</Row>
									</div>
								</div>
							</Row>
						</div>
					</div>
				</Container>
			</section>
			{/* <!-- End blog section --> */}
			<Footer />
		</Layout>
	);
}

export default JobsPage;